var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        modalNova: true,
        closeOutside: false,
        titulo: _vm.titulo,
        width: 600
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "container-imagem-assinatura" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/images/assinatura.png"),
              alt: "assinatura",
              width: "268px",
              height: "200px"
            }
          })
        ]),
        _c("p", [_vm._v(_vm._s(_vm.texto))]),
        _c(
          "div",
          { staticClass: "form-assinatura" },
          [
            _c(
              "validation-observer",
              { ref: "observer" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: { label: "Senha:", required: true }
                          }),
                          _c("el-input", {
                            staticClass: "input",
                            class: { erro: errors.length },
                            attrs: { type: "password" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.confirmarAssinatura($event)
                              }
                            },
                            model: {
                              value: _vm.assinatura,
                              callback: function($$v) {
                                _vm.assinatura = $$v
                              },
                              expression: "assinatura"
                            }
                          }),
                          _c("br"),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                key: "botao-confirma",
                attrs: { type: "primary", disabled: !_vm.assinatura },
                on: {
                  click: function($event) {
                    return _vm.confirmarAssinatura()
                  }
                }
              },
              [_vm._v("Finalizar")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f768590", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f768590","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAssinatura.vue
// module id = null
// module chunks = 